import { Separator } from '@betterment/samba-react';
import { ActivityDrawerLayout } from '@betterment/shared-components/src/components/activity/components/drawer/common/ActivityDrawerLayout';
import { DrawerListRow } from '@betterment/shared-components/src/components/activity/components/drawer/common/DrawerListRow';

import { ActivityItemFragment } from '../../../../graphql/fragments/activityItem.generated';
import { NarrowTypename } from '../../../../graphql/utils/narrow-typename';

export const AllocationChange: React.FC<{
  item: NarrowTypename<ActivityItemFragment, 'ActivityItemAllocationChange'>;
}> = ({ item }) => {
  return (
    <ActivityDrawerLayout title="Portfolio Change">
      <DrawerListRow label="Account" value={item.subAccount?.envelope.purpose?.name ?? ''} />
      <Separator />
      <DrawerListRow label="Change details" value={item.newPortfolioDescription} />
      <Separator />
      <DrawerListRow label="Note" value="-" />
      <Separator />
    </ActivityDrawerLayout>
  );
};
